import { ColorModeScript } from '@chakra-ui/react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'

import { App } from './App'
import { AuthProvider } from './context/AuthContext'
import { theme } from './theme'

const container = document.getElementById('app')
if (!container) throw new Error('Failed to find the root element')

const root = createRoot(container!)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      // Další globální nastavení
    },
  },
})

window.addEventListener('error', (event) => {
  if (
    event.message.includes(
      'ResizeObserver loop completed with undelivered notifications',
    )
  ) {
    console.warn('Ignored ResizeObserver loop error')
    event.stopImmediatePropagation()
    event.preventDefault()
  }
})

root.render(
  // <React.StrictMode>
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <ColorModeScript />
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />

      <App />

      <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
    </AuthProvider>
  </QueryClientProvider>,
  // </React.StrictMode>
)
